var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.96145L2.08216 0L13.4231 10.6899C13.6059 10.8612 13.751 11.0649 13.85 11.2892C13.949 11.5136 14 11.7542 14 11.9972C14 12.2402 13.949 12.4808 13.85 12.7052C13.751 12.9296 13.6059 13.1333 13.4231 13.3045L2.08216 24L0.00196171 22.0386L10.6463 12L0 1.96145Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.db2471c50053803bb0d7f3f79cf5514b.svg";
export { ForwardRef as ReactComponent };